module.exports = __webpack_public_path__ + "static/wft-07f05eb91332064b5536df17b64e7119.png";